/* Publish by EComposer at 2024-06-18 12:03:34*/
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-8ix1n2phlhy"]=  window.__ectimmers["ecom-8ix1n2phlhy"] || {};
if(!this.$el)return;const e=this.$el,i=e.querySelector(".ecom-text_view-more-btn"),t=e.querySelector(".ecom-text_view-less-btn"),n=e.querySelector(".text-content.ecom-html");!n||(i&&i.addEventListener("click",()=>{n.classList.remove("ecom-text--is-mark"),n.style.maxHeight="",i.style.display="none",t.style.display=""}),t&&t.addEventListener("click",()=>{n.classList.add("ecom-text--is-mark"),n.style.maxHeight="var(--ecom-text-height)",t.style.display="none",i.style.display=""}))

                    });
                    
                        document.querySelectorAll('.ecom-8ix1n2phlhy').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-8ix1n2phlhy', settings: {},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-oq1y8synz7"]=  window.__ectimmers["ecom-oq1y8synz7"] || {};
if(this.settings.link==="lightbox"&&this.settings.lightbox==="yes"&&window.EComModal&&this.$el){var e=this.$el.querySelector("[ecom-modal]");new window.EComModal(e,{cssClass:["ecom-container-lightbox-"+this.id]})}

                    });
                    
                        document.querySelectorAll('.ecom-oq1y8synz7').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-oq1y8synz7', settings: {"link":"custom","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-srp97l59iee').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-srp97l59iee', settings: {"link":"custom","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-xdpdlh6bd4p').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-xdpdlh6bd4p', settings: {"link":"custom","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-0g6nwpicb56').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-0g6nwpicb56', settings: {"link":"custom","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-jqpo99wmm3s').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-jqpo99wmm3s', settings: {"link":"custom","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-gj1eng5j08').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-gj1eng5j08', settings: {"link":"custom","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-0zvsdolur0x').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-0zvsdolur0x', settings: {"link":"custom","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-d510i96147e').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-d510i96147e', settings: {"link":"custom","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-zksm2uqxp09').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-zksm2uqxp09', settings: {"link":"custom","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-yln533tqmzm').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-yln533tqmzm', settings: {"link":"custom","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-p4ejku7xa4').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-p4ejku7xa4', settings: {"link":"custom","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-wcenk36wm2c').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-wcenk36wm2c', settings: {"link":"custom","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-p3j4ix4vcis').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-p3j4ix4vcis', settings: {"link":"custom","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-amcfb5fthm').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-amcfb5fthm', settings: {"link":"custom","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-bqa5zu3suee').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-bqa5zu3suee', settings: {"link":"custom","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-1gpigkhx4c4').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-1gpigkhx4c4', settings: {"link":"custom","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-cvrivzuxqo6').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-cvrivzuxqo6', settings: {"link":"custom","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-fkvi6d83vzh').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-fkvi6d83vzh', settings: {"link":"custom","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-jshxwtfd3b').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-jshxwtfd3b', settings: {"link":"custom","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-956lok51p7c').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-956lok51p7c', settings: {"link":"custom","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-koujbkvak6').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-koujbkvak6', settings: {"link":"custom","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-7gylzn368ef').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-7gylzn368ef', settings: {"link":"custom","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-go4qa3svqve').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-go4qa3svqve', settings: {"link":"custom","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-07nfgtqfd9wf').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-07nfgtqfd9wf', settings: {"link":"custom","lightbox":"no"},isLive: true});
                        });
                    

                })();
            
;try{
 
} catch(error){console.error(error);}